module.exports = "/_next/static/media/d4ac7b480951b8a581e4797c086f031e.svg";